import useSWR from "swr";

import getBuyerDomain from "../ApiCalls/getBuyerDomain";
import getSales from "../ApiCalls/getSales";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

export function useGetSales(days: string, isToUseAuthZero: boolean) {
  const buyerAPIDomain = getBuyerDomain(isToUseAuthZero);

  const { accessToken } = useAuth(!isToUseAuthZero);

  const url = new URL(`${buyerAPIDomain.href}/saleprogramme/BCAOffsite?days=${days}`);
  const { data, error } = useSWR(
    url && (accessToken || !isToUseAuthZero)
      ? [url.href, accessToken, isToUseAuthZero]
      : null,
    getSales,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  return { data, error };
}
